// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-delete-task-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($id: uuid!) {
  delete_tasks_tasks_tags(where: { id: { _eq: $id } }) {
    affected_rows
  }
}

`